<div class="dialog">
    <div class="modal-header" ngbAutofocus>
        <div class="row w-100" w-100>
            <div class="col-4 title-center">
                <h4 class="modal-title">Asset Transfer</h4>
                <div class="col-5 counter" *ngIf="currentView == viewPage.Assets">
                    [{{this.currentPage}}/{{this.pageCount}}]</div>
            </div>
        </div>
    </div>
    <p *ngIf="showMessage" class="modal-header  modal-message">This section of the form must be completed. If multiple
        vehicles have been
        selected,
        this form will apply to all
        selected vehicles. However, if different transporters are collecting the vehicles, each vehicle must be
        completed individually.</p>
    <img class="modal-close" (click)="dismissModal()" alt="Dismiss modal">

    <div class="modal-body asset-transfer">
        <div class="container">
            <ng-container *ngIf="currentView === viewPage.DriverDetails">
                <form [formGroup]="assetTransferForm" class="replace-padding">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-section">
                                <div class="form-control-asset collectionReference">
                                    <label for="collectionReference" class="form-label">1. Collection Reference: <span
                                            class="required-box">*</span>
                                    </label>
                                    <input id="collectionReferenceInput" type="text" #collectionReferenceInput
                                        class="form-control input-text collectionReference"
                                        formControlName="collectionReference" placeholder="Collection Reference" />
                                    <span class="placeholder-line"></span>
                                </div>
                            </div>
                            <div class="form-section">
                                <div class="form-control-asset transporterVRM">
                                    <div class="form-label">2. Transporter VRM <b>(If Applicable)</b>:</div>
                                    <input id="transporterVRM" class="form-control input-text transporterVRM"
                                        formControlName="transporterVRM" type="text" placeholder="Transporter VRM">
                                    <span class="placeholder-line"></span>
                                </div>
                            </div>

                            <div class="form-section">
                                <div class="form-control-asset transporterVRM">
                                    <label for="transportCompanyName" class="form-label">3. Transport Company
                                        Name:</label>
                                    <input id="transportCompanyName"
                                        class="form-control input-text transportCompanyName"
                                        formControlName="transportCompanyName" type="text"
                                        placeholder="Transport Company Name" autocomplete="off">
                                    <span class="placeholder-line"></span>
                                </div>
                            </div>

                        </div>
                        <div class="col-6">

                            <div class="form-section">
                                <label for="driverName" class="form-label">4. Driver’s Name: <span
                                        class="required-box">*</span></label>
                                <input id="driverName" class="form-control input-text driverName"
                                    formControlName="driverName" type="text" placeholder="Driver’s Name" required
                                    autocomplete="off">
                                <span class="placeholder-line"></span>

                            </div>
                            <div>
                                <div class="form-section">
                                    <div class="form-label">5. Please take a picture of the I.D. <span
                                            class="required-box">*</span></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <app-image-input class="child-stretch flex-container flex-grow"
                                        [parameterName]="'DriverID'" [imageData]="imgs" [group]="null"
                                        [displayImages]="true" [requiredImageType]="3" [save]="saveNotifier"
                                        [back]="backNotifier">
                                    </app-image-input>
                                </div>
                                <div class="col-6">

                                    <a [href]="driverCheckURL" class="checkId-btn button_purple" target="_blank"
                                        rel="noopener noreferrer">
                                        Check I.D.
                                        <span class="checkId-btn-icon"> <img
                                                src="../../assets/icons/check_driver_id.svg"></span>
                                    </a>
                                </div>
                            </div>

                            <div class="asset-transfer-btn next-center">
                                <button class="modal-button button_green" type="button"
                                    [ngClass]="{ 'active': assetTransferForm.valid && isImageAdded, 'invalid': !assetTransferForm.valid || !isImageAdded}"
                                    [disabled]="!assetTransferForm.valid || !isImageAdded"
                                    (click)="nextView(viewPage.Assets, false)">
                                    <span class="next-btn-icon"
                                        [ngClass]="{'active': assetTransferForm.valid && isImageAdded, 'invalid': !assetTransferForm.valid || !isImageAdded}"></span>
                                    <span class="next-btn-span">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="currentView === viewPage.Assets">
                <form [formGroup]="vehicle.Form" class="replace-padding">
                    <div class="row">
                        <div class="col-6 row-container">
                            <div class="derivative-list">
                                <app-vehicle-image [vehicleImage]="vehicle.ImageUrl"
                                    [defaultVehicleImage]="vehicle.DefaultVehicleImageUrl" [selectedGrade]="0"
                                    [showGrade]="false">
                                </app-vehicle-image>
                                <app-vehicle-details-qq [vrm]="vehicle.Vrm" [vehicleDescription]="vehicle"
                                    [isQQDetails]="false">
                                </app-vehicle-details-qq>
                            </div>
                        </div>
                        <div class="col-6 center">
                            <div class="form-label">6. Vehicle items included <b> (Multiple can be selected):</b>
                            </div>
                            <div class="row">
                                <div class="col-12 keys-panel">
                                    <label ngbButtonLabel class=" option-btn keys"
                                        [ngClass]="{'active' : vehicle.Form.controls.key.value}">
                                        <input class="btn-check" type="checkbox" ngbButton formControlName="key">
                                        Key
                                    </label>

                                    <label ngbButtonLabel class=" option-btn keys"
                                        [ngClass]="{'active' : vehicle.Form.controls.spareKey.value}">
                                        <input type="checkbox" ngbButton formControlName="spareKey">
                                        Spare Key
                                    </label>
                                    <label ngbButtonLabel class=" option-btn keys"
                                        [ngClass]="{'active' : vehicle.Form.controls.v5.value}">
                                        <input type="checkbox" ngbButton formControlName="v5">
                                        V5
                                    </label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 keys-panel">
                                    <label ngbButtonLabel class=" option-btn keys"
                                        [ngClass]="{'active' : vehicle.Form.controls.serviceHistory.value}">
                                        <input type="checkbox" ngbButton formControlName="serviceHistory">
                                        Service History
                                    </label>
                                    <label ngbButtonLabel class=" option-btn keys"
                                        [ngClass]="{'active' : vehicle.Form.controls.satNavCard.value}">
                                        <input type="checkbox" ngbButton formControlName="satNavCard">
                                        Sat Nav Card
                                    </label>
                                    <label ngbButtonLabel class=" option-btn keys"
                                        [ngClass]="{'active' : vehicle.Form.controls.other.value}">
                                        <input type="checkbox" ngbButton formControlName="other">
                                        Other
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="vehicle.IsVan" class="row">
                                <div class="form-section">
                                    <div class="form-control-asset">
                                        <div class="form-label">7. Is the van empty? <span class="required-box">*</span>
                                        </div>
                                        <div ngbRadioGroup class="option-btn-container ">
                                            <label ngbButtonLabel class="list-button"
                                                [ngClass]="{'active' : vehicle.Form.get('vanEmpty')?.value === 1}">
                                                <input class="btn-check" formControlName="vanEmpty" type="radio"
                                                    [value]="1">
                                                Yes
                                            </label>
                                            <label ngbButtonLabel class="list-button"
                                                [ngClass]="{'active' : vehicle.Form.get('vanEmpty')?.value === 2}">
                                                <input class="btn-check" formControlName="vanEmpty" type="radio"
                                                    [value]="2">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="modal-footer-asset-transfer">
                            <div class="asset-transfer-btn center" *ngIf="isBackButtonActive">
                                <button class="modal-button button_blue next_details" (click)="previousPage()"
                                    [disabled]="pageCount == 0"
                                    [ngClass]="{'active-blue': isBackButtonActive, 'invalid':isFirstPage}">
                                    <span class="back-btn-icon"
                                        [ngClass]="{'active-blue': isBackButtonActive, 'invalid': isFirstPage }"></span>
                                    <span class="quick-quote-span">Back</span>
                                </button>
                            </div>
                            <div class="asset-transfer-btn center">
                                <button class="modal-button button_green next_details" (click)="handleNext()"
                                    [disabled]="!canContinueForVehicle(vehicle)"
                                    [ngClass]="{'active': canContinueForVehicle(vehicle), 'invalid':!canContinueForVehicle(vehicle)}">
                                    <span class="next-btn-icon"
                                        [ngClass]="{'active': canContinueForVehicle(vehicle), 'invalid':!canContinueForVehicle(vehicle)}"></span>
                                    <span class="quick-quote-span">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="currentView === viewPage.DriverSignature">
            </ng-container>
        </div>
    </div>
</div>